import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import fr from "./fr.json";
import {
  detectBrowserLanguage,
  languageStorageKey,
  readLanguagePreference,
  LanguagePreference,
} from "./language";

export function browserLanguage() {
  return detectBrowserLanguage(
    navigator.languages?.length ? navigator.languages : [navigator.language],
  );
}

const preference = readLanguagePreference();
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng: preference === "auto" ? browserLanguage() : preference,
  fallbackLng: "en",
  supportedLngs: ["en", "fr"],
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  initImmediate: false,
});

function updateDocumentLanguage() {
  document.documentElement.lang = i18n.resolvedLanguage || "en";
  document.title = i18n.t("PentaOffice · Workplace, together");
}
i18n.on("languageChanged", updateDocumentLanguage);
updateDocumentLanguage();

export function setLanguagePreference(value: LanguagePreference) {
  try {
    if (value === "auto") localStorage.removeItem(languageStorageKey);
    else localStorage.setItem(languageStorageKey, value);
  } catch {
    // Changing the language remains available without persistence.
  }
  void i18n.changeLanguage(value === "auto" ? browserLanguage() : value);
  window.dispatchEvent(new Event("language-preference-changed"));
}
window.addEventListener("languagechange", () => {
  if (readLanguagePreference() === "auto")
    void i18n.changeLanguage(browserLanguage());
});
window.addEventListener("storage", (event) => {
  if (event.key === languageStorageKey || event.key === null) {
    const value = readLanguagePreference();
    void i18n.changeLanguage(value === "auto" ? browserLanguage() : value);
    window.dispatchEvent(new Event("language-preference-changed"));
  }
});

export const locale = () =>
  i18n.resolvedLanguage === "fr" ? "fr-FR" : "en-GB";
export default i18n;
